import type { DataLayerInfo, PageInfo } from '../../../../shared/types'

export const getCRTopicSubVerticalDataLayer = (pageInfo: PageInfo) => {
  const crTopicDataLayer: DataLayerInfo = {
    ...pageInfo,
    topicName: pageInfo.sub_vertical,
    content_type: 'topic',
  }

  delete crTopicDataLayer.sub_vertical

  return crTopicDataLayer
}
